/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { ExtensibleNode } from '../../../core/models/ExtensibleNode';
import { IIndexedNode } from '../../../core/models/IIndexedNode';
import { IReferenceNode } from '../../../core/models/IReferenceNode';
import { INamed } from '../../../core/models/common/INamed';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOas30Visitor } from '../visitors/IOas30Visitor';
import { Oas30CallbackPathItem } from './Oas30CallbackPathItem';
import { Document } from '../../../core/models/Document';
import { Node } from '../../../core/models/Node';

/**
 * Constructor.
 * @param {string} name
 * @class
 * @extends ExtensibleNode
 * @author eric.wittmann@gmail.com
 */
export class Oas30Callback extends ExtensibleNode implements IIndexedNode<Oas30CallbackPathItem>, INamed, IReferenceNode {
    /*private*/ items : any = <any>({});

    /*private*/ _name : string;

    public $ref : string;

    public constructor(name : string) {
        super();
        if(this._name===undefined) this._name = null;
        if(this.$ref===undefined) this.$ref = null;
        this._name = name;
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOas30Visitor = <IOas30Visitor><any>visitor;
        viz.visitCallback(this);
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#getName()
     * @return {string}
     */
    public getName() : string {
        return this._name;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#rename(java.lang.String)
     * @param {string} newName
     */
    public rename(newName : string) {
        this._name = newName;
    }

    /**
     * 
     * @return {string}
     */
    public getReference() : string {
        return this.$ref;
    }

    /**
     * 
     * @param {string} reference
     */
    public setReference(reference : string) {
        this.$ref = reference;
    }

    /**
     * Returns a single path item by name.
     * @param {string} name
     * @return {Oas30CallbackPathItem}
     */
    public getPathItem(name : string) : Oas30CallbackPathItem {
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this.items, name);
    }

    /**
     * Returns an array of all the path items.
     * @return {Oas30CallbackPathItem[]}
     */
    public getPathItems() : Array<Oas30CallbackPathItem> {
        let rval : Array<Oas30CallbackPathItem> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.items));
        return rval;
    }

    /**
     * Adds a path item.
     * @param {string} name
     * @param {Oas30CallbackPathItem} pathItem
     * @return {Oas30CallbackPathItem}
     */
    public addPathItem(name : string, pathItem : Oas30CallbackPathItem) : Oas30CallbackPathItem {
        /* put */(this.items[name] = pathItem);
        return pathItem;
    }

    /**
     * Gets a list of all the path names.
     * @return {string[]}
     */
    public getPathItemNames() : Array<string> {
        let rval : Array<string> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* keySet */Object.keys(this.items));
        return rval;
    }

    /**
     * Removes a single path item child model by name.
     * @param {string} path
     * @return {Oas30CallbackPathItem}
     */
    public removePathItem(path : string) : Oas30CallbackPathItem {
        return /* remove */(map => { let deleted = this.items[path];delete this.items[path];return deleted;})(this.items);
    }

    /**
     * Creates an OAS path item object.
     * @param {string} path
     * @return {Oas30CallbackPathItem}
     */
    public createPathItem(path : string) : Oas30CallbackPathItem {
        let rval : Oas30CallbackPathItem = new Oas30CallbackPathItem(path);
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#getItem(java.lang.String)
     * @param {string} name
     * @return {Oas30CallbackPathItem}
     */
    public getItem(name : string) : Oas30CallbackPathItem {
        return this.getPathItem(name);
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#getItems()
     * @return {Oas30CallbackPathItem[]}
     */
    public getItems() : Array<Oas30CallbackPathItem> {
        return this.getPathItems();
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#getItemNames()
     * @return {string[]}
     */
    public getItemNames() : Array<string> {
        return this.getPathItemNames();
    }

    public addItem$java_lang_String$io_apicurio_datamodels_openapi_v3_models_Oas30CallbackPathItem(name : string, item : Oas30CallbackPathItem) {
        this.addPathItem(name, item);
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#addItem(java.lang.String, io.apicurio.datamodels.core.models.Node)
     * @param {string} name
     * @param {Oas30CallbackPathItem} item
     */
    public addItem(name? : any, item? : any) : any {
        if(((typeof name === 'string') || name === null) && ((item != null && item instanceof <any>Oas30CallbackPathItem) || item === null)) {
            return <any>this.addItem$java_lang_String$io_apicurio_datamodels_openapi_v3_models_Oas30CallbackPathItem(name, item);
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#deleteItem(java.lang.String)
     * @param {string} name
     * @return {Oas30CallbackPathItem}
     */
    public deleteItem(name : string) : Oas30CallbackPathItem {
        return this.removePathItem(name);
    }
}
Oas30Callback["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30Callback";
Oas30Callback["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.IIndexedNode","io.apicurio.datamodels.core.models.common.INamed"];




